var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c(
        "div",
        {
          class: [
            "table-container-wrapper",
            _vm.tableStatus.editable ? "show-table-bottom-operate" : "",
          ],
        },
        [
          _vm.updateGuide && _vm.updateGuideStep === 1
            ? _c(
                "div",
                {
                  staticClass: "updateGuideTitle",
                  style: { height: `${_vm.updateGuideTitleHeight}px` },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "updateGuideTip",
                      style: { top: `${_vm.updateGuideTitleHeight + 10}px` },
                    },
                    [
                      _c("div", { staticClass: "margin-bottom-10" }, [
                        _vm._v("1/2"),
                      ]),
                      _c("div", { staticClass: "margin-bottom-10" }, [
                        _vm._v(_vm._s(_vm.$t("filterFunction"))),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "guide-btn",
                          on: { click: _vm.nextClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("next")))]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              key: _vm.tableKey,
              ref: "finalTable",
              staticClass: "wl-table fixedFont",
              attrs: {
                border: "",
                height: "100%",
                data: _vm.splitData,
                "row-key": "id",
                "tree-props": _vm.defaultProps,
                stripe: "",
                "row-class-name": _vm.tableRowClassName,
                "header-cell-class-name": _vm.updateGuideClass,
                "default-expand-all": _vm.expand,
                "tcvf-table-name": "pbc-f-table",
              },
              on: { "header-dragend": _vm.headerDrag },
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                            },
                          },
                          [
                            !_vm.expand
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-angle-double-right openAll",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.expandAll },
                                })
                              : _c("i", {
                                  staticClass:
                                    "fa fa-angle-double-down openAll",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.expandAll },
                                }),
                            _vm.tableStatus.editable
                              ? _c("el-checkbox", {
                                  attrs: { value: _vm.checkedAll },
                                  on: { change: _vm.SelectionAll },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.tableStatus.editable &&
                        (!scope.row.childPbcGroup ||
                          !scope.row.childPbcGroup.length)
                          ? _c("el-checkbox", {
                              attrs: {
                                disabled:
                                  _vm.tableStatus.mode === "setStatus" &&
                                  scope.row.status !== "2" &&
                                  scope.row.status !== "3",
                                value: _vm.checkIsSelected(scope.row.id),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleSelectionChange(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm.showColumns.includes("entityName")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "entityName",
                      width: "200",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("TABLE_HEAD_EntityList"),
                    },
                  })
                : _vm._e(),
              _vm.showColumns.includes("serialNo")
                ? _c("el-table-column", {
                    staticClass: "fixedColumn",
                    attrs: { width: _vm.serialNoColumnWidth },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("serialNo")) +
                                      "\n                        "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.serialNoHere
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        4203938885
                                      ),
                                    },
                                    [
                                      [
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder: _vm.$t(
                                              "serialNoPlaceholder"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.serialNoHere,
                                            callback: function ($$v) {
                                              _vm.serialNoHere = $$v
                                            },
                                            expression: "serialNoHere",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        scope.row.topicSrc !== 1 ||
                                        scope.row.pid !== null,
                                      expression:
                                        "scope.row.topicSrc !== 1 || scope.row.pid !== null",
                                    },
                                  ],
                                },
                                [_vm._v(_vm._s(scope.row.serialNo))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      568879687
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("topicName")
                ? _c("el-table-column", {
                    staticClass: "fixedColumn",
                    attrs: {
                      prop: "topicName",
                      width: "200",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("TABLE_HEADER_topicName"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("TABLE_HEADER_topicName")) +
                                      "\n                        "
                                  ),
                                  _c("TopicMultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.topicHere,
                                      labelKey: "topicName",
                                      valueKey: "topicId",
                                      inputFilterKey: ["topicName", "topicId"],
                                      options: _vm.topicList,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.topicHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2177768561
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("topicDesc")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "topicDesc",
                      width: "220",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("PAFE_PBC_LIST_DESC")) +
                                      "\n                        "
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.topicDesHere,
                                      labelKey: "topicDesc",
                                      valueKey: "topicId",
                                      inputFilterKey: ["topicDesc", "topicId"],
                                      options: _vm.topicDesList,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.topicDesHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3433545546
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("createDate")
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "createDate",
                        "label-class-name": `table-header-editable ${
                          _vm.isClientUser ? "not-allow" : ""
                        }`,
                        width: "150",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(scope.row.createDate)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        169678552
                      ),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "div",
                          { staticClass: "header-with-popup" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("create_date")) +
                                "\n                        "
                            ),
                            _c("DatePickerPopover", {
                              attrs: {
                                value: _vm.createDateHere,
                                hidePopperSearch: _vm.hidePopperSearch,
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.createDateHere = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.showColumns.includes("dueDateStamp")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "dueDateStamp",
                      "label-class-name": `table-header-editable ${
                        _vm.isClientUser ? "not-allow" : ""
                      }`,
                      width: "210",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t("Due_Date_can_not_edit"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      on: { click: _vm.showHeaderDueDayPicker },
                                    },
                                    [
                                      _vm.getUser.userType === "1"
                                        ? _c("i", {
                                            ref: "header-calendar-icon",
                                            staticClass:
                                              "el-icon-date table-header-edit-cls",
                                            attrs: {
                                              title: _vm.$t(
                                                "pbc_batch_upload_tip"
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _c("el-date-picker", {
                                        ref: "header-dueday-picker",
                                        staticStyle: {
                                          visibility: "hidden",
                                          position: "absolute",
                                          top: "0",
                                          left: "0",
                                          "z-index": "-1",
                                        },
                                        attrs: {
                                          disabled: _vm.isClientUser,
                                          clearable: false,
                                        },
                                        on: { change: _vm.dateBatchChange },
                                        model: {
                                          value: _vm.editDueDayPicker,
                                          callback: function ($$v) {
                                            _vm.editDueDayPicker = $$v
                                          },
                                          expression: "editDueDayPicker",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("KPMG_Due_Date")) +
                                          "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c("DatePickerPopover", {
                                attrs: {
                                  value: _vm.dueTimeHere,
                                  hidePopperSearch: _vm.hidePopperSearch,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.dueTimeHere = $event
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.isClientUser && !_vm.isParentNode(scope.row)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(scope.row.dueDay)
                                      )
                                    ),
                                  ])
                                : !_vm.isParentNode(scope.row)
                                ? _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: false,
                                      disabled:
                                        _vm.isClientUser ||
                                        _vm.isAccepted(scope.row.status) ||
                                        _vm.sourceTypeDisabled(
                                          scope.row.sourceType
                                        ) ||
                                        _vm.isUploaded(scope.row.status),
                                      "picker-options": _vm.getOption(
                                        scope.row.periodEndDateStamp
                                      ),
                                      type: "date",
                                    },
                                    on: {
                                      change: (val) =>
                                        _vm.onDuedayChange(val, scope.row.id),
                                    },
                                    model: {
                                      value: scope.row.dueDay,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "dueDay", $$v)
                                      },
                                      expression: "scope.row.dueDay",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4189449848
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("confirmDayStamp")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "confirmDayStamp",
                      "label-class-name": "table-header-editable",
                      width: "240",
                      label: _vm.$t("Client_Confirmed_Due_Date"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t("Due_Date_can_not_edit"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click:
                                          _vm.showHeaderConfirmDayStampPicker,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        ref: "header-calendar-icon",
                                        staticClass:
                                          "el-icon-date table-header-edit-cls",
                                        attrs: {
                                          title: _vm.$t("pbc_batch_upload_tip"),
                                        },
                                      }),
                                      _c("el-date-picker", {
                                        ref: "header-confirm-day-picker",
                                        staticStyle: {
                                          visibility: "hidden",
                                          position: "absolute",
                                          top: "0",
                                          left: "0",
                                          "z-index": "-1",
                                        },
                                        attrs: { clearable: false },
                                        on: {
                                          change: _vm.dateBatchConfirmDayChange,
                                        },
                                        model: {
                                          value: _vm.editConfirmDayPicker,
                                          callback: function ($$v) {
                                            _vm.editConfirmDayPicker = $$v
                                          },
                                          expression: "editConfirmDayPicker",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("Client_Confirmed_Due_Date")
                                          ) +
                                          "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c("DatePickerPopover", {
                                attrs: {
                                  value: _vm.clientConfirmDateHere,
                                  hidePopperSearch: _vm.hidePopperSearch,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.clientConfirmDateHere = $event
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.isParentNode(scope.row)
                                ? _c("el-date-picker", {
                                    staticClass: "wl-item wl-date-item",
                                    attrs: {
                                      type: "date",
                                      disabled:
                                        _vm.isAccepted(scope.row.status) ||
                                        _vm.isUploaded(scope.row.status) ||
                                        _vm.sourceTypeDisabled(
                                          scope.row.sourceType
                                        ),
                                      "picker-options": _vm.getOption(
                                        scope.row.periodEndDateStamp
                                      ),
                                    },
                                    on: {
                                      change: (val) =>
                                        _vm.onConfirmDayChange(
                                          val,
                                          scope.row.id
                                        ),
                                    },
                                    model: {
                                      value: scope.row.confirmDayStamp,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "confirmDayStamp",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.confirmDayStamp",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1051212086
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("sourceType")
                ? _c("el-table-column", {
                    attrs: { prop: "sourceType", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "row",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "el-dropdown",
                                    {
                                      attrs: {
                                        trigger: "click",
                                        placement: "bottom-start",
                                      },
                                      on: {
                                        command:
                                          _vm.handlePatchSetSourceOfInformation,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "el-dropdown-link",
                                          attrs: {
                                            title: _vm.$t(
                                              "PAGE_MATTERLOG_SOURCE_OF_INFORMATION"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-edit-outline table-header-edit-cls",
                                            attrs: {
                                              title: _vm.$t(
                                                "pbc_batch_upload_tip"
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "PAGE_MATTERLOG_SOURCE_OF_INFORMATION"
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm.isClientUser
                                        ? _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  key: -2,
                                                  attrs: {
                                                    command: { value: "-2" },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "NOT_APPLICABLE_CLIENT"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            _vm._l(
                                              _vm.sourceTypes,
                                              function (item) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: item.value,
                                                    attrs: { command: item },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            item.internationalStatus
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.sourceOfInfoHere,
                                      labelKey: "rlabel",
                                      valueKey: "value",
                                      inputFilterKey: ["rlabel", "value"],
                                      options: _vm.sourceTypes.map((v) => ({
                                        rlabel: _vm.$t(v.internationalStatus),
                                        ...v,
                                      })),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.sourceOfInfoHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.isClientUser && !_vm.isParentNode(scope.row)
                                ? [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          disabled: !_vm.getSourceTypeKey(
                                            scope.row.sourceType
                                          ),
                                          effect: "dark",
                                          content:
                                            _vm.getSourceTypeKey(
                                              scope.row.sourceType
                                            ) &&
                                            _vm.$t(
                                              _vm.getSourceTypeKey(
                                                scope.row.sourceType
                                              )
                                            ),
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled:
                                                scope.row.status === "4" ||
                                                scope.row.sourceType === "-2",
                                              title:
                                                _vm.getSourceTypeKey(
                                                  scope.row.sourceType
                                                ) &&
                                                _vm.$t(
                                                  _vm.getSourceTypeKey(
                                                    scope.row.sourceType
                                                  )
                                                ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeSourceType(
                                                  scope.row
                                                )
                                              },
                                              "visible-change": function (
                                                $event
                                              ) {
                                                return _vm.sourceTypeVisible(
                                                  $event,
                                                  scope.row.sourceType
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.sourceType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "sourceType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.sourceType",
                                            },
                                          },
                                          [
                                            scope.row.sourceType != null
                                              ? _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      _vm.getSourceTypeKey(
                                                        scope.row.sourceType
                                                      )
                                                    ),
                                                    value: scope.row.sourceType,
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("el-option", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "NOT_APPLICABLE_CLIENT"
                                                ),
                                                value: "-2",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : !_vm.isParentNode(scope.row)
                                ? [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          disabled: !_vm.getSourceTypeKey(
                                            scope.row.sourceType
                                          ),
                                          effect: "dark",
                                          content:
                                            _vm.getSourceTypeKey(
                                              scope.row.sourceType
                                            ) &&
                                            _vm.$t(
                                              _vm.getSourceTypeKey(
                                                scope.row.sourceType
                                              )
                                            ),
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled:
                                                scope.row.status === "4",
                                              title:
                                                _vm.getSourceTypeKey(
                                                  scope.row.sourceType
                                                ) &&
                                                _vm.$t(
                                                  _vm.getSourceTypeKey(
                                                    scope.row.sourceType
                                                  )
                                                ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.onChangeRow(
                                                  scope.row,
                                                  "sourceType"
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.sourceType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "sourceType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.sourceType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.sourceTypes,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: _vm.$t(
                                                    item.internationalStatus
                                                  ),
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3529981411
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("status")
                ? _c("el-table-column", {
                    attrs: { prop: "status", width: "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("FORM_LABEL_status")) +
                                      "\n                        "
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.statusHere,
                                      labelKey: "xlabel",
                                      valueKey: "value",
                                      inputFilterKey: ["xlabel", "value"],
                                      dayOverDue: _vm.dayOverDueHere,
                                      daysUntilDue: _vm.daysUntilDueHere,
                                      options: [
                                        {
                                          xlabel: _vm.$t("Overdue"),
                                          internationalStatus: "Overdue",
                                          label: "Overdue",
                                          value: "5",
                                          showDayOverDue: true,
                                          showDaysUntilDue: false,
                                        },
                                        {
                                          xlabel: _vm.$t("DaysUntilDue"),
                                          internationalStatus: "DaysUntilDue",
                                          label: "DaysUntilDue",
                                          value: "6",
                                          showDayOverDue: false,
                                          showDaysUntilDue: true,
                                        },
                                        ..._vm.filterStatusList.map((v) => ({
                                          xlabel: _vm.$t(v.internationalStatus),
                                          showDayOverDue: false,
                                          showDaysUntilDue: false,
                                          ...v,
                                        })),
                                      ],
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.statusHere = $event
                                      },
                                      "update:dayOverDue": function ($event) {
                                        _vm.dayOverDueHere = $event
                                      },
                                      "update:day-over-due": function ($event) {
                                        _vm.dayOverDueHere = $event
                                      },
                                      "update:daysUntilDue": function ($event) {
                                        _vm.daysUntilDueHere = $event
                                      },
                                      "update:days-until-due": function (
                                        $event
                                      ) {
                                        _vm.daysUntilDueHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return !_vm.isParentNode(scope.row)
                              ? [
                                  ["-3", "-2"].includes(scope.row.sourceType)
                                    ? _c("div", [_vm._v("————")])
                                    : _c("div", [
                                        _vm.isClientUser
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                _vm.statusList,
                                                function (item) {
                                                  return item.value ==
                                                    scope.row.status
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: item.key,
                                                          class: `status_background_${_vm.mappingStatus(
                                                            scope.row
                                                          )}`,
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "padding-left":
                                                                  "22px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                    " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .status ===
                                                                      "1"
                                                                      ? _vm.formatDueDayDes(
                                                                          scope
                                                                            .row
                                                                            .dueDayDesc
                                                                        )
                                                                      : _vm.$t(
                                                                          item.internationalStatus
                                                                        )
                                                                  ) +
                                                                  "\n                                "
                                                              ),
                                                            ]
                                                          ),
                                                          scope.row.status ==
                                                            "3" &&
                                                          scope.row.comments &&
                                                          scope.row.comments
                                                            .length > 0
                                                            ? _c(
                                                                "el-popover",
                                                                {
                                                                  attrs: {
                                                                    "popper-class":
                                                                      "breakWord",
                                                                    placement:
                                                                      "right",
                                                                    title: "",
                                                                    width:
                                                                      "200",
                                                                    trigger:
                                                                      "click",
                                                                    content:
                                                                      scope.row
                                                                        .comments,
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-commenting comments",
                                                                    attrs: {
                                                                      slot: "reference",
                                                                      "aria-hidden":
                                                                        "true",
                                                                    },
                                                                    slot: "reference",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                }
                                              ),
                                              0
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    class: `wl-item status_background_${_vm.mappingStatus(
                                                      scope.row
                                                    )}`,
                                                    attrs: {
                                                      "collapse-tags": "",
                                                      disabled:
                                                        (scope.row.status !==
                                                          "2" &&
                                                          scope.row.status !==
                                                            "3") ||
                                                        _vm.sourceTypeDisabled(
                                                          scope.row.sourceType
                                                        ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.onChangeOne(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.status",
                                                    },
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.statusList,
                                                      function (item) {
                                                        return [
                                                          _c("el-option", {
                                                            key: item.value,
                                                            attrs: {
                                                              label:
                                                                item.value ===
                                                                "1"
                                                                  ? _vm.formatDueDayDes(
                                                                      scope.row
                                                                        .dueDayDesc
                                                                    )
                                                                  : _vm.$t(
                                                                      item.internationalStatus
                                                                    ),
                                                              disabled:
                                                                item.value ==
                                                                "1",
                                                              value: item.value,
                                                            },
                                                          }),
                                                        ]
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                scope.row.comments &&
                                                scope.row.comments.length > 0
                                                  ? _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          "popper-class":
                                                            "breakWord",
                                                          placement: "right",
                                                          title: "",
                                                          width: "200",
                                                          trigger: "click",
                                                          content:
                                                            scope.row.comments,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-commenting comments",
                                                          attrs: {
                                                            slot: "reference",
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                          slot: "reference",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                      ]),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("clientUserName")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "clientUserName",
                      "label-class-name": `table-header-editable ${
                        _vm.isClientUser ? "not-allow" : ""
                      }`,
                      width: "300",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _vm.isClientUser
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "el-dropdown-link",
                                      attrs: {
                                        title: _vm.$t(
                                          "TABLE_HEADER_clientUserName"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "TABLE_HEADER_clientUserName"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-dropdown",
                                    {
                                      attrs: {
                                        trigger: "click",
                                        placement: "bottom-start",
                                      },
                                      on: { command: _vm.handleCommand },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "el-dropdown-link",
                                          attrs: {
                                            title: _vm.$t(
                                              "TABLE_HEADER_clientUserName"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-edit-outline table-header-edit-cls",
                                            attrs: {
                                              title: _vm.$t(
                                                "pbc_batch_upload_tip"
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "TABLE_HEADER_clientUserName"
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: _vm.$t(
                                                "TABLE_HEADER_clientUserName"
                                              ),
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.clientOwnerDropdownFilterInput,
                                              callback: function ($$v) {
                                                _vm.clientOwnerDropdownFilterInput =
                                                  $$v
                                              },
                                              expression:
                                                "clientOwnerDropdownFilterInput",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.clientOwnerDropdownList,
                                            function (item, index) {
                                              return _c(
                                                "el-dropdown-item",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    command: {
                                                      userId: item.id,
                                                      userType: "2",
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(item.userName) +
                                                      "\n                            "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                              _c("MultiSelectPopver", {
                                attrs: {
                                  hidePopperSearch: _vm.hidePopperSearch,
                                  value: _vm.clientResponsibleHere,
                                  labelKey: "userName",
                                  valueKey: "userId",
                                  inputFilterKey: ["userName", "userId"],
                                  options: _vm.clientOwnerList,
                                  initPopperData: _vm.selectAllUser,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.clientResponsibleHere = $event
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.isParentNode(scope.row) &&
                              scope.row.clientUserName
                                ? _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(scope.row.clientUserName) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.getUser.userType === "1" &&
                              !_vm.isParentNode(scope.row) &&
                              !_vm.isAccepted(scope.row.status) &&
                              !_vm.sourceTypeDisabled(scope.row.sourceType)
                                ? _c("i", {
                                    staticClass: "el-icon-edit item-edit-cls",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editInCharge(scope.row, 1)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3957407265
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("kpmgUserName")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "kpmgUserName",
                      width: "250",
                      "label-class-name": `table-header-editable ${
                        _vm.isClientUser ? "not-allow" : ""
                      }`,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _vm.isClientUser
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "el-dropdown-link",
                                      attrs: {
                                        title: _vm.$t(
                                          "TABLE_HEADER_kpmgUserName"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t("TABLE_HEADER_kpmgUserName")
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-dropdown",
                                    {
                                      attrs: {
                                        trigger: "click",
                                        placement: "bottom-start",
                                      },
                                      on: { command: _vm.handleCommand },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "el-dropdown-link",
                                          attrs: {
                                            title: _vm.$t(
                                              "TABLE_HEADER_kpmgUserName"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-edit-outline table-header-edit-cls",
                                            attrs: {
                                              title: _vm.$t(
                                                "pbc_batch_upload_tip"
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "TABLE_HEADER_kpmgUserName"
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: _vm.$t(
                                                "TABLE_HEADER_kpmgUserName"
                                              ),
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.kpmgOwnerDropdownFilterInput,
                                              callback: function ($$v) {
                                                _vm.kpmgOwnerDropdownFilterInput =
                                                  $$v
                                              },
                                              expression:
                                                "kpmgOwnerDropdownFilterInput",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.kpmgOwnerDropdownList,
                                            function (item, index) {
                                              return _c(
                                                "el-dropdown-item",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    command: {
                                                      userId: item.id,
                                                      userType: "1",
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(item.userName) +
                                                      " (" +
                                                      _vm._s(
                                                        item.profitCenter
                                                      ) +
                                                      ")\n                            "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                              _c("MultiSelectPopver", {
                                attrs: {
                                  hidePopperSearch: _vm.hidePopperSearch,
                                  value: _vm.kpmgResponsibleHere,
                                  labelKey: "rlabel",
                                  valueKey: "id",
                                  inputFilterKey: ["rlabel", "id"],
                                  options: _vm.kpmgOwnerList.map((v) => ({
                                    rlabel:
                                      v.userName + "(" + v.profitCenter + ")",
                                    ...v,
                                  })),
                                  initPopperData: _vm.selectAllUser,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.kpmgResponsibleHere = $event
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.isParentNode(scope.row) &&
                              scope.row.kpmgUserName
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.kpmgUserName)),
                                  ])
                                : _vm._e(),
                              _vm.getUser.userType === "1" &&
                              !_vm.isParentNode(scope.row) &&
                              !_vm.isAccepted(scope.row.status) &&
                              !_vm.sourceTypeDisabled(scope.row.sourceType)
                                ? _c("i", {
                                    staticClass: "el-icon-edit item-edit-cls",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editInCharge(scope.row, 0)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3368484147
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("uploadedBy")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "uploadedBy",
                      width: "150",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("TABLE_HEADER_uploadedBy"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("TABLE_HEADER_uploadedBy")) +
                                  "                    \n                    "
                              ),
                              _c("MultiSelectPopver", {
                                attrs: {
                                  hidePopperSearch: _vm.hidePopperSearch,
                                  initPopperData: _vm.selectAllUser,
                                  value: _vm.lastedUploadUserAccountHere,
                                  labelKey: "rlabel",
                                  valueKey: "userAccount",
                                  inputFilterKey: ["rlabel", "userAccount"],
                                  options: [
                                    ..._vm.kpmgOwnerList.map((v) => ({
                                      rlabel:
                                        v.userName + "(" + v.profitCenter + ")",
                                      ...v,
                                    })),
                                    ..._vm.clientOwnerList.map((v) => {
                                      let obj = {}
                                      if (
                                        v.userName !== _vm.$t("common_empty")
                                      ) {
                                        obj = { rlabel: v.userName, ...v }
                                      }
                                      return obj
                                    }),
                                  ],
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.lastedUploadUserAccountHere = $event
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      670613121
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("uploadedDateStamp")
                ? _c("el-table-column", {
                    attrs: { prop: "uploadedDateStamp", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("TABLE_HEADER_uploadedDate")
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.uploadTimeHere,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.uploadTimeHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("formatDateToSecond")(
                                      scope.row.uploadedDateStamp
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      765935029
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("periodEndDateStamp")
                ? _c("el-table-column", {
                    attrs: { prop: "periodEndDateStamp", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("TABLE_HEADER_periodEndDate")
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.periodEndDateHere,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.periodEndDateHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      scope.row.periodEndDateStamp
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2618534270
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("fileNameList")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "fileNameList",
                      align: "center",
                      fixed: "right",
                      width: "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("TABLE_HEADER_fileNameList")
                                      ) +
                                      "\n                        "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.fileNameHere
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3329292709
                                      ),
                                    },
                                    [
                                      [
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder:
                                              _vm.$t("fileNameKeyword"),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.fileNameHere,
                                            callback: function ($$v) {
                                              _vm.fileNameHere = $$v
                                            },
                                            expression: "fileNameHere",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.fileNameList.length > 0,
                                      expression:
                                        "scope.row.fileNameList.length > 0",
                                    },
                                  ],
                                  staticClass: "file-number-hint",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showFileDetail(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(scope.row.fileNameList.length)
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2367420798
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("upload")
                ? _c("el-table-column", {
                    attrs: {
                      width: "70",
                      align: "center",
                      label: _vm.$t("COMMON_UPLOAD"),
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.childPbcGroup == null ||
                              scope.row.childPbcGroup.length <= 0
                                ? _c("i", {
                                    class: [
                                      !_vm.hasPermission("upload") ||
                                      _vm.sourceTypeDisabled(
                                        scope.row.sourceType
                                      ) ||
                                      _vm.isAccepted(scope.row.status)
                                        ? "wl-icon-not-upload"
                                        : "wl-icon-upload",
                                      "el-icon-upload",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpload(scope.row)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1060604702
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("messageNum")
                ? _c("el-table-column", {
                    attrs: {
                      width: "120",
                      align: "center",
                      label: _vm.$t("TABLE_HEAD_COMMENTS"),
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                        "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.commentDateHere,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.commentDateHere = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.childPbcGroup == null ||
                              scope.row.childPbcGroup.length <= 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex item-center justify-center",
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          scope.row.todayCommentCount > 0
                                            ? "wl-icon-messageBoard"
                                            : "wl-icon-messageBoardNull",
                                          "el-icon-s-comment",
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.openMessageBoard(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                      scope.row.todayCommentCount
                                        ? _c("span", [
                                            _c(
                                              "span",
                                              { staticClass: "message-today" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.todayCommentCount
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("span", [_vm._v("/")]),
                                          ])
                                        : _vm._e(),
                                      scope.row.messageNum > 0
                                        ? _c("span", [
                                            _vm._v(
                                              " " + _vm._s(scope.row.messageNum)
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3839195323
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tableStatus.editable
        ? _c(
            "div",
            { staticClass: "wl-btn-container" },
            [
              _c(
                "el-button",
                { staticClass: "cancel-btn", on: { click: _vm.deselectAll } },
                [_vm._v(_vm._s(_vm.$t("comment_reSet")) + " ")]
              ),
              _vm.tableStatus.mode === "setStatus"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: { disabled: _vm.emptyChosen },
                      on: { click: _vm.changeStatus },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("COMMON_CHANGESTATUS")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.downloading
                ? _c("i", {
                    staticClass: "el-icon-loading downloading-placeholder",
                    attrs: { title: "downloading" },
                  })
                : _vm.tableStatus.mode === "download"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: { disabled: _vm.emptyChosen || _vm.downloading },
                      on: { click: _vm.downLoad },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v(_vm._s(_vm.$t("COMMON_DOWNLOAD")))]),
                        _vm.downloading
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("COMMON_ING"))),
                              _c("span", { staticClass: "dotting" }),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm.tableStatus.mode === "export"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: { disabled: _vm.emptyChosen || _vm.downloading },
                      on: { click: _vm.downLoad },
                    },
                    [
                      _c("span", [
                        _c("span", [_vm._v(_vm._s(_vm.$t("BATCH_export")))]),
                        _vm.downloading
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("COMMON_ING"))),
                              _c("span", { staticClass: "dotting" }),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.tableStatus.mode === "sendEmail"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: { disabled: _vm.emptyChosen },
                      on: { click: _vm.sendEmail },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("PAGE_CLIENTUSER_EMAIL_PBC")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-pagination",
        {
          staticClass: "wl-pagination",
          attrs: {
            "current-page": _vm.pagination.pageNum,
            "page-size": _vm.pagination.pageSize,
            layout: "prev, pager, next, slot, total",
            total: _vm.pagination.total,
          },
          on: { "current-change": _vm.onPageChange },
        },
        [
          _c(
            "span",
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.onSizeChange },
                  model: {
                    value: _vm.pagination.pageSize,
                    callback: function ($$v) {
                      _vm.$set(_vm.pagination, "pageSize", $$v)
                    },
                    expression: "pagination.pageSize",
                  },
                },
                _vm._l(_vm.pageOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.addVisible
        ? _c("upload", {
            attrs: {
              saveLoading: _vm.btnLoading,
              initData: _vm.initData,
              onCancel: _vm.toggleAddVisible,
            },
          })
        : _vm._e(),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.initData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.onUploadFileAfter,
              messageType: _vm.messageType,
              siteId: _vm.siteId,
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("TABLE_HEADER_fileNameList"),
            visible: _vm.fileDetailVisbile,
            width: "70%",
            top: "10vh",
            "before-close": _vm.handleClose,
          },
        },
        [
          _c("filelist-table", {
            attrs: {
              slot: "",
              tableData: _vm.detailRow.fileNameList,
              downloadAble: _vm.downloadAble,
              curUserName: _vm.curUserName,
              getPbcList: () => _vm.onUploadFileAfter(),
            },
            on: {
              "on-file-download": (rowParam) =>
                _vm.downloadFile(rowParam, _vm.detailRow.id, _vm.detailRow),
            },
            slot: "default",
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isClientInCharge
              ? _vm.$t("TABLE_HEADER_clientUserName")
              : _vm.$t("TABLE_HEADER_kpmgUserName"),
            visible: _vm.inChargeVisible,
            "close-on-click-modal": false,
            width: "400px",
          },
          on: {
            close: function ($event) {
              _vm.inChargeVisible = false
            },
          },
        },
        [
          _vm.isClientInCharge
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", filterable: "" },
                  model: {
                    value: _vm.currentIncharge.clientInCharge,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentIncharge, "clientInCharge", $$v)
                    },
                    expression: "currentIncharge.clientInCharge",
                  },
                },
                _vm._l(_vm.clientOwnerList, function (item) {
                  return _c("el-option", {
                    key: item.userId,
                    attrs: { label: item.userName, value: item.userId },
                  })
                }),
                1
              )
            : _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", filterable: "" },
                  model: {
                    value: _vm.currentIncharge.kpmgInCharge,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentIncharge, "kpmgInCharge", $$v)
                    },
                    expression: "currentIncharge.kpmgInCharge",
                  },
                },
                _vm._l(_vm.kpmgOwnerList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.userName + " ( " + item.profitCenter + " ) ",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.isClientInCharge
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      on: {
                        click: function ($event) {
                          return _vm.onChargeUserChange(
                            _vm.currentIncharge.clientInCharge,
                            "2"
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btn_submit")))]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      on: {
                        click: function ($event) {
                          return _vm.onChargeUserChange(
                            _vm.currentIncharge.kpmgInCharge,
                            "1"
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btn_submit")))]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("PAGE_CLIENTUSER_EMAIL_PBC"),
            visible: _vm.patchSendEmail.show,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.patchSendEmail, "show", $event)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { "label-width": "200px", "label-position": "left" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("recevier") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.patchSendEmail.choosed,
                            callback: function ($$v) {
                              _vm.$set(_vm.patchSendEmail, "choosed", $$v)
                            },
                            expression: "patchSendEmail.choosed",
                          },
                        },
                        _vm._l(_vm.patchSendEmail.options, function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v.userName, value: v.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("ccer") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.patchSendEmail.cc,
                            callback: function ($$v) {
                              _vm.$set(_vm.patchSendEmail, "cc", $$v)
                            },
                            expression: "patchSendEmail.cc",
                          },
                        },
                        _vm._l(_vm.patchSendEmail.ccOptions, function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v.userName, value: v.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { loading: _vm.patchSendEmail.loading || _vm.loading },
                  on: {
                    click: function ($event) {
                      _vm.patchSendEmail.show = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: {
                    type: "primary",
                    loading: _vm.patchSendEmail.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handlePatchSendEmail("myself")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("send_me_a_preview")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: {
                    type: "primary",
                    loading: _vm.patchSendEmail.loading || _vm.loading,
                  },
                  on: { click: _vm.handlePatchSendEmail },
                },
                [_vm._v(_vm._s(_vm.$t("comment_send")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }